import { buryPoint } from '@/Common/plugins/buried-point';

export default {
  onLoginGotTime(value, eventLabel) {
    buryPoint.timing({
      name: '首页-脚本获取时长',
      value,
      eventCategory: '首页',
      eventLabel
    });
  },
  onLoginRenderingTime(value, eventLabel) {
    buryPoint.timing({
      name: '首页-页面渲染时长',
      value,
      eventCategory: '首页',
      eventLabel
    });
  },
  helpGuide() {
    buryPoint.event({
      action: '新手引导-使用功能',
      eventCategory: '新手引导'
    });
  },
  doHelpGuideTime(value, eventLabel) {
    buryPoint.timing({
      name: '新手引导-使用时长',
      value,
      eventCategory: '新手引导',
      eventLabel
    });
  },
  noviceGuideEntrance(type) {
    const op = {
      1: '首次进入平台时自动展示',
      2: '顶部导航栏的帮助',
      3: '悬浮气泡',
      4: 'Home页的帮助栏',
      5: 'Home页的推荐任务Banner'
    };
    buryPoint.event({
      action: '新手引导-入口位置',
      eventCategory: '新手引导',
      eventLabel: op[type]
    });
  },
  questionnaire(type) {
    const op = {
      2: '顶部导航栏的帮助',
      3: '悬浮气泡'
    };
    buryPoint.event({
      action: '调查问卷-问卷填写',
      eventCategory: '调查问卷',
      eventLabel: op[type]
    });
  },
  skipNoviceGuide() {
    buryPoint.event({
      action: '新手引导-跳过新手引导',
      eventCategory: '新手引导'
    });
  },
  webChat(type) {
    const op = {
      1: '顶部导航栏下拉选项',
      2: '悬浮气泡',
      3: 'support菜单栏'
    };
    buryPoint.event({
      action: '自动应答机器人-使用自动应答机器人',
      eventCategory: '自动应答机器人',
      eventLabel: op[type]
    });
  },
  feedback(flag) {
    const op = {
      1: '顶部导航栏下拉选项',
      2: '悬浮气泡',
      3: 'Home页左上角-反馈问题'
    };
    buryPoint.event({
      action: '意见反馈-使用意见反馈',
      eventCategory: '意见反馈',
      eventLabel: op[flag]
    });
  },
  doFeedback(type) {
    const op = {
      0: '反馈成功',
      1: '网络异常'
    };
    buryPoint.event({
      action: '意见反馈-提交意见反馈',
      eventCategory: '意见反馈',
      eventLabel: op[type]
    });
  },
  doFeedbackTime(value, eventLabel) {
    buryPoint.timing({
      name: '意见反馈-完成时长',
      value,
      eventCategory: '意见反馈',
      eventLabel
    });
  },
  linkageCompanyInfo(status) {
    const op = {
      0: '绑定成功',
      1: '绑定失败'
    };
    buryPoint.event({
      action: '绑定企业信息-绑定反馈',
      eventCategory: '绑定企业信息',
      eventLabel: op[status]
    });
  },
  linkageCompanyInfoPage() {
    buryPoint.event({
      action: '绑定企业信息-绑定企业信息访问',
      eventCategory: '绑定企业信息'
    });
  },
  openPrivacyPolicy(flag) {
    const op = {
      0: 'admin',
      1: '员工'
    };
    buryPoint.event({
      action: '查看隐私声明-使用功能',
      eventCategory: '查看隐私声明',
      eventLabel: op[flag]
    });
  },
  openServiceAgree(flag) {
    const op = {
      0: 'admin',
      1: '员工'
    };
    buryPoint.event({
      action: '查看服务协议-使用功能',
      eventCategory: '查看服务协议',
      eventLabel: op[flag]
    });
  },
  navigateSitePage(flag) {
    const op = {
      1: '左侧导航面板',
      2: 'Home页-站点概览',
      3: 'Home页-最近访问站点',
      4: '远程运维购买成功页-推荐操作',
      5: 'Home页-站点概览卡片-最常访问站点',
      6: '设备运维服务详情弹窗-站点名称',
      7: '定时发送报表空白页-管理站点'
    };
    buryPoint.event({
      action: '浏览站点模块-进入方式',
      eventCategory: '浏览站点模块',
      eventLabel: op[flag]
    });
  },
  navigateCompanyPage(flag) {
    const op = {
      1: '左侧导航面板',
      2: 'Home页-常用操作'
    };
    buryPoint.event({
      action: '查看公司信息-入口位置',
      eventCategory: '查看公司信息',
      eventLabel: op[flag]
    });
  },
  navigateCreateRolePage(flag) {
    const op = {
      1: '角色与权限页面',
      2: 'Home页-常用操作'
    };
    buryPoint.event({
      action: '创建角色-入口位置',
      eventCategory: '创建角色',
      eventLabel: op[flag]
    });
  },
  createRole() {
    buryPoint.event({
      action: '创建角色-使用功能',
      eventCategory: '创建角色'
    });
  },
  editRole() {
    buryPoint.event({
      action: '编辑角色-使用功能',
      eventCategory: '编辑角色'
    });
  },
  deleteRole() {
    buryPoint.event({
      action: '删除角色-使用功能',
      eventCategory: '删除角色'
    });
  },
  enterEmployeePage(where) {
    const op = {
      1: '左侧导航面板',
      2: 'Home页-员工概览',
      3: '员工账号数购买成功页-推荐操作',
      4: '员工账号数购买成功(您的员工人数大约已购账号数)页-员工管理'
    };
    buryPoint.event({
      action: '查看员工-入口位置',
      eventCategory: '查看员工',
      eventLabel: op[where]
    });
  },
  createEmployeePage(where) {
    const op = {
      1: '员工页面',
      2: 'Home页-常用操作',
      3: '角色页面'
    };
    buryPoint.event({
      action: '添加员工-入口位置',
      eventCategory: '添加员工',
      eventLabel: op[where]
    });
  },
  addEmployeeFail(where) {
    const op = {
      1: '启用账号数达上限，添加失败'
    };
    buryPoint.event({
      action: '添加员工-添加失败',
      eventCategory: '添加员工',
      eventLabel: op[where]
    });
  },
  enableEmployeeTimes() {
    buryPoint.event({
      action: '启用员工账号-使用功能',
      eventCategory: '启用员工账号'
    });
  },
  enableEmployee(where) {
    const op = {
      1: '启用成功',
      2: '启用账号数达上限，启用失败'
    };
    buryPoint.event({
      action: '启用员工账号-启用结果',
      eventCategory: '启用员工账号',
      eventLabel: op[where]
    });
  },
  closeEmployeeTimes() {
    buryPoint.event({
      action: '禁用员工账号-使用功能',
      eventCategory: '禁用员工账号'
    });
  },
  closeEmployee(where) {
    const op = {
      1: '禁用成功'
    };
    buryPoint.event({
      action: '禁用员工账号-禁用结果',
      eventCategory: '禁用员工账号',
      eventLabel: op[where]
    });
  },
  createEmployee() {
    buryPoint.event({
      action: '创建角色-使用功能',
      eventCategory: '添加员工'
    });
  },
  deleteEmployee() {
    buryPoint.event({
      action: '删除角色-使用功能',
      eventCategory: '删除员工'
    });
  },
  editEmployee() {
    buryPoint.event({
      action: '修改员工角色/权限-使用功能',
      eventCategory: '修改员工角色/权限'
    });
  },
  enterLogPage() {
    buryPoint.event({
      action: '查看操作日志-查看信息',
      eventCategory: '查看操作日志'
    });
  },
  searchLog() {
    buryPoint.event({
      action: '检索操作日志-使用功能',
      eventCategory: '检索操作日志'
    });
  },
  editCompanyInfo() {
    buryPoint.event({
      action: '编辑公司信息-使用功能',
      eventCategory: '编辑公司信息'
    });
  },
  coBrandingSwitch(flag) {
    const op = {
      1: '启用Co-Branding',
      2: '关闭Co-Branding'
    };
    buryPoint.event({
      action: `${op[flag] }-使用功能`,
      eventCategory: op[flag]
    });
  },
  employeeSignup() {
    buryPoint.event({
      action: '员工用户注册-使用功能',
      eventCategory: '员工用户注册'
    });
  },
  employeeResult(flag) {
    const op = {
      1: '注册成功',
      2: '注册失败'
    };
    buryPoint.event({
      action: '员工用户注册-注册结果',
      eventCategory: '员工用户注册',
      eventLabel: op[flag]
    });
  },
  completeCompanyClick() {
    buryPoint.event({
      action: '绑定企业信息-使用功能',
      eventCategory: '绑定企业信息'
    });
  },
  subscribe() {
    buryPoint.event({
      action: '订阅营销活动-使用功能',
      eventCategory: '订阅营销活动'
    });
  },
  subscribeEntrance(flag) {
    const op = {
      1: '顶部按钮-账号下拉选项',
      2: '悬浮气泡'
    };
    buryPoint.event({
      action: '订阅营销活动-入口位置',
      eventCategory: '订阅营销活动',
      eventLabel: op[flag]
    });
  },
  subscribeResult(flag) {
    const op = {
      1: '订阅成功',
      2: '订阅失败'
    };
    buryPoint.event({
      action: '订阅营销活动-订阅结果',
      eventCategory: '订阅营销活动',
      eventLabel: op[flag]
    });
  },
  unSubscribe() {
    buryPoint.event({
      action: '取消订阅营销活动-使用功能',
      eventCategory: '取消订阅营销活动'
    });
  },
  unSubscribeEntrance(flag) {
    const op = {
      1: '顶部按钮-账号下拉选项',
      2: '悬浮气泡',
      3: '邮件链接'
    };
    buryPoint.event({
      action: '取消订阅营销活动-入口位置',
      eventCategory: '取消订阅营销活动',
      eventLabel: op[flag]
    });
  },
  unSubscribeResult(flag) {
    const op = {
      1: '取消订阅成功',
      2: '取消订阅失败'
    };
    buryPoint.event({
      action: '取消订阅营销活动-订阅结果',
      eventCategory: '取消订阅营销活动',
      eventLabel: op[flag]
    });
  },
  openShareUrlToRegist() {
    buryPoint.event({
      action: '激励活动-打开分享链接',
      eventCategory: '激励活动'
    });
  },
  openVideoCapacityTool() {
    buryPoint.event({
      action: '录像容量-查看信息',
      eventCategory: '录像容量'
    });
  },
  openNvrTool() {
    buryPoint.event({
      action: 'NVR通道接入-查看信息',
      eventCategory: 'NVR通道接入'
    });
  },
  openFocalLengthTool() {
    buryPoint.event({
      action: '摄像机焦距-查看信息',
      eventCategory: '摄像机焦距'
    });
  },
  openBandwidthTool() {
    buryPoint.event({
      action: '带宽计算-查看信息',
      eventCategory: '带宽计算'
    });
  },
  cloudChannelCountTool(flag) {
    buryPoint.event({
      action: '云存储设备开通通道-查看信息',
      eventCategory: '通道开通状态',
      eventLabel: flag
    });
  },
  userManual(flag) {
    const op = {
      1: '顶部导航栏“？”下拉选项',
      2: 'Home页帮助栏'
    };
    buryPoint.event({
      action: '查看Usermanual-使用功能',
      eventCategory: '查看Usermanual',
      eventLabel: op[flag]
    });
  },
  openDviceCompatibilityList() {
    buryPoint.event({
      action: '查看Device Compatibility List-使用功能',
      eventCategory: '查看Device Compatibility List'
    });
  },
  openDatasheet() {
    buryPoint.event({
      action: '查看Datasheet-使用功能',
      eventCategory: '查看Datasheet'
    });
  },
  openWhatsNew() {
    buryPoint.event({
      action: '查看WhatsNew-使用功能',
      eventCategory: '查看WhatsNew'
    });
  },
  viewServiceMarket(flag) {
    const op = {
      1: '左侧导航面板',
      2: 'Home页-顶部￥按钮下拉菜单',
      3: 'Home页-常用操作-服务市场'
    };
    buryPoint.event({
      action: '查看服务市场-入口位置',
      eventCategory: '查看服务市场',
      eventLabel: op[flag]
    });
  },
  openShareLink(url) {
    buryPoint.event({
      action: '平台外链-点击量',
      eventCategory: '平台外链',
      eventLabel: url
    });
  },
  serviceCap(index) {
    const op = {
      1: '远程运维的设备数已达上限',
      2: '托管设备数已超限'
    };

    buryPoint.event({
      action: '服务已达上线-出现提示',
      eventCategory: '服务已达上线',
      eventLabel: op[index]
    });
  },
  identityType(params) {
    const op = {
      1: '未选择身份登录时自动出现',
      2: '认证前判断未选择身份时出现'
    };

    buryPoint.event({
      eventCategory: '身份类型',
      action: '出现身份选择弹窗',
      eventLabel: op[params]
    });
  },
  identityTypeConfirm(params) {
    const op = {
      0: '安装商',
      1: '系统集成商',
      2: '接警中心',
      3: '终端用户',
      4: 'IT人员',
      5: '其他'
    };
    buryPoint.event({
      eventCategory: '身份类型',
      action: '完成选择',
      eventLabel: op[params]
    });
  },
  goHCWeb() {
    buryPoint.event({
      eventCategory: '身份类型',
      action: '前往Hik-Connect'
    });
  },
  reSelect() {
    buryPoint.event({
      eventCategory: '身份类型',
      action: '重新选择'
    });
  },
  hcCustomer(params) {
    const op = {
      1: '身份选择弹窗选择终端用户后',
      2: '企业信息页中用户类型选择为终端用户点击保存后'
    };

    buryPoint.event({
      eventCategory: '身份类型',
      action: '出现Hik-Connect引导弹窗',
      eventLabel: op[params]
    });
  },
  unauthCount(params) {
    const op = {
      1: '公司详情页-立即认证',
      2: '公司详情页-重新认证',
      3: '认证失败原因弹窗-重新认证',
      4: 'Service Market顶部-立即认证按钮',
      5: 'Service Market-Health Monitoring Package卡片-气泡提示',
      6: 'Service Market-Employee account add-on卡片-气泡提示',
      7: '运维管理-付费按钮气泡提示',
      8: '健康检测-空状态',
      9: '异常推送-空状态',
      10: '定时报表-空状态',
      11: '运维服务激活-购买时提示',
      12: 'Home页-注册完成提示',
      13: '领取免费运维包',
      14: '使用云考勤',
      15: '创建HCC'
    };

    buryPoint.event({
      eventCategory: '账号认证',
      action: '企业未认证弹窗出现',
      eventLabel: op[params]
    });
  },
  authAddDevice(params) {
    const op = {
      1: '信息确认弹窗-下一步',
      2: '我的-认证需添加1台设备横幅-去添加'
    };

    buryPoint.event({
      eventCategory: '账号认证',
      action: '账号认证-线上认证-添加设备',
      eventLabel: op[params]
    });
  },
  authAddDeviceBtn() {
    buryPoint.event({
      eventCategory: '账号认证',
      action: '账号认证-去添加设备'
    });
  },
  authAddDeviceDone() {
    buryPoint.event({
      eventCategory: '账号认证',
      action: '账号认证-完成设备添加'
    });
  },
  infoConfirmAuthCode() {
    buryPoint.event({
      eventCategory: '账号认证',
      action: '认证码认证-信息确认弹窗'
    });
  },
  backEditAuth() {
    buryPoint.event({
      eventCategory: '账号认证',
      action: '认证码认证-返回修改'
    });
  },
  backEditAuthOnline() {
    buryPoint.event({
      eventCategory: '账号认证',
      action: '线上认证-返回修改'
    });
  },
  authcodeAuth() {
    buryPoint.event({
      eventCategory: '账号认证',
      action: '认证码认证'
    });
  },
  onlineAuth() {
    buryPoint.event({
      eventCategory: '账号认证',
      action: '线上认证'
    });
  },
  onlineAuthConfirm() {
    buryPoint.event({
      eventCategory: '账号认证',
      action: '线上认证-信息确认弹窗'
    });
  },
  // 服务激活码购买运维Package
  priceShow(params) {
    const op = {
      1: '健康检测',
      2: '云存储',
      3: '员工扩充'
    };
    buryPoint.event({
      eventCategory: '查看价格单',
      action: '曝光量',
      eventLabel: op[params]
    });
  },
  // 领取赠送设备运维包
  firstGetShow(params) {
    const op = {
      1: '站点详情页',
      2: '设备添加结果页',
      3: '设备迁移结果页'
    };
    buryPoint.event({
      eventCategory: '领取赠送设备运维包',
      action: '初次领取曝光量',
      eventLabel: op[params]
    });
  },
  firstGetClick(params) {
    const op = {
      1: '站点详情页-一键领取',
      2: '站点详情页-设备卡片-免费领取',
      3: '设备添加结果页-一键领取',
      4: '设备迁移结果页-一键领取'
    };
    buryPoint.event({
      eventCategory: '领取赠送设备运维包',
      action: '初次领取按钮点击',
      eventLabel: op[params]
    });
  },
  firstGetConfirm() {
    buryPoint.event({
      eventCategory: '领取赠送设备运维包',
      action: '初次领取确认领取'
    });
  },
  firstResult(params) {
    buryPoint.event({
      eventCategory: '领取赠送设备运维包',
      action: '初次领取结果',
      eventLabel: params
    });
  },
  reGetShow(params) {
    const op = {
      1: '站点详情页',
      2: '设备添加结果页',
      3: '设备迁移结果页'
    };
    buryPoint.event({
      eventCategory: '领取赠送设备运维包',
      action: '重新领取按钮曝光量',
      eventLabel: op[params]
    });
  },
  reGetClick(params) {
    const op = {
      1: '站点详情页-重新领取',
      2: '站点详情页-设备卡片-重新领取',
      3: '设备添加结果页-重新领取',
      4: '设备迁移结果页-重新领取'
    };
    buryPoint.event({
      eventCategory: '领取赠送设备运维包',
      action: '重新领取按钮点击',
      eventLabel: op[params]
    });
  },
  reGetConfirm() {
    buryPoint.event({
      eventCategory: '领取赠送设备运维包',
      action: '重新领取确认'
    });
  },
  reResult(params) {
    buryPoint.event({
      eventCategory: '领取赠送设备运维包',
      action: '重新领取结果',
      eventLabel: params
    });
  },
  cardUseClick(params) {
    const op = {
      1: '云考勤',
      2: '客流统计',
      3: '人员测温',
      4: 'HCC-视频',
      5: 'HCC-车载'
    };
    buryPoint.event({
      eventCategory: '站点增值功能卡片',
      action: '立即使用',
      eventLabel: op[params]
    });
  },
  siteCompleteClick(params) {
    const op = {
      1: '云考勤',
      2: '客流统计',
      3: '人员测温',
      4: 'HCC-视频',
      5: 'HCC-车载'
    };
    buryPoint.event({
      eventCategory: '站点增值功能卡片',
      action: '完成站点选择',
      eventLabel: op[params]
    });
  },
  cobrandingTip() {
    buryPoint.event({
      eventCategory: '开启Co-branding提示',
      action: '出现弹窗'
    });
  },
  cobrandingTipEnable() {
    buryPoint.event({
      eventCategory: '开启Co-branding提示',
      action: '启用'
    });
  },
  cobrandingTipDisable() {
    buryPoint.event({
      eventCategory: '开启Co-branding提示',
      action: '暂不启用'
    });
  }
};
